module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "account-ds"
  }, [_c('div', {
    staticClass: "bar bar-nav account-top-m"
  }, [_c('router-link', {
    staticClass: "button button-link button-nav pull-left",
    attrs: {
      "to": "/customer/account/index"
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  })]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("message.reset_password_success")))])], 1)]), _vm._v(" "), (_vm.errormsg) ? _c('div', {
    staticClass: "fecshop_message"
  }, [_c('div', {
    staticClass: "error-msg"
  }, [_c('div', [_vm._v("\n                    " + _vm._s(_vm.errormsg) + "\n                ")])])]) : _vm._e(), _vm._v(" "), (_vm.correctmsg) ? _c('div', {
    staticClass: "fecshop_message"
  }, [_c('div', {
    staticClass: "correct-msg"
  }, [_c('div', [_vm._v("\n                    " + _vm._s(_vm.correctmsg) + "\n                ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "customer-forgot-success"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("message.reset_accout_success")) + " \n            "), _c('router-link', {
    attrs: {
      "to": "/customer/account/login"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t("message.click_here")) + "\n            ")]), _vm._v("\n            " + _vm._s(_vm.$t("message.to_login")) + " .\n        ")], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-da7f4cec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/body/customer/account/ResetpasswordSuccess.vue
// module id = 268
// module chunks = 1